import { ReactNode } from 'react'
import { Container } from './Icon.style'

export type IconProps = {
  icon: ReactNode
  background: string
}

export function Icon({ background, icon }: IconProps) {
  return <Container background={background}>{icon}</Container>
}
